const subNavStyles = {
  tab: {
    color: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    lineHeight: 1.86,
    letterSpacing: 1.87,
    whiteSpace: "nowrap",
    maxWidth: "none",
  },
  menuItem: {
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "FordAntennaCondMedium, sans-serif",
    backgroundColor: "#102b4e",
    color: "white",
    lineHeight: 1.86,
    letterSpacing: 1.87,
    whiteSpace: "nowrap",
    maxWidth: "none",
    minWidth: "393px",
  },
  highlightedMenuItem: {
    fontSize: "14px",
    color: "white",
    fontFamily: "FordAntennaCondMedium, sans-serif",
    fontWeight: 500,
    lineHeight: 1.86,
    letterSpacing: 1.87,
    whiteSpace: "nowrap",
    boxShadow:
      "inset 0 1px 3px 0 rgba(18, 51, 88, 0.09), inset 12px 3px 11px 4px rgba(20, 57, 95, 0.27)",
    backgroundImage: "linear-gradient(to bottom, #2861a4, #123359)",
    maxWidth: "none",
    minWidth: "393px",
  },
  highlighted: {
    color: "white",
    fontFamily: "FordAntennaCondMedium, sans-serif",
    fontWeight: 500,
    lineHeight: 1.86,
    letterSpacing: 1.87,
    whiteSpace: "nowrap",
    boxShadow:
      "inset 0 1px 3px 0 rgba(18, 51, 88, 0.09), inset 12px 3px 11px 4px rgba(20, 57, 95, 0.27)",
    backgroundImage: "linear-gradient(to bottom, #2861a4, #123359)",
    maxWidth: "none",
  },
  dropdown: {
    minWidth: "390px",
    width: "100%",
    textAlign: "left",
    borderRadius: 3,
    border: "solid 1px #4d4d4d",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
  },
  modelDropDown: {
    height: 35,
    width: 250,
    textAlign: "left",
    borderRadius: 3,
    border: "solid 1px #4d4d4d",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
  },
  smallDropDown: {
    height: 35,
    width: 200,
    textAlign: "left",
    borderRadius: 3,
    border: "solid 1px #4d4d4d",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
  },
  disabledDropDown: {
    height: 35,
    width: 250,
    textAlign: "left",
    borderRadius: 3,
    border: "solid 1px #d8d8d8",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
  },

  item: {
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
  },
  nonOnboardedDealer: {
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
    background: "rgba(225, 37, 70, 0.1)",
  },
  disabledItem: {
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#d8d8d8",
  },
  icon: {
    top: "calc(50% - 12px)",
    right: 0,
    color: "#102b4e",
    position: "absolute",
    paddingRight: 10,
    cursor: "pointer",
    pointerEvents: "none",
  },
  disabledIcon: {
    top: "calc(50% - 12px)",
    right: 0,
    color: "#d8d8d8",
    position: "absolute",
    paddingRight: 10,
    cursor: "pointer",
    pointerEvents: "none",
  },
  hide: {
    display: "none",
  },
  disabledTab: {
    color: "#979797",
    fontFamily: "FordAntenna-Regular, sans-serif",
    lineHeight: 1.86,
    letterSpacing: 1.87,
    whiteSpace: "nowrap",
    maxWidth: "none",
    cursor: "default",
  },
};

export default subNavStyles;
